import React from "react";


const Card = ({otherLinks ="javascript:void(0)", link = null, imageSrc, title = "Galaxy Fit", description = "Starting from GH 15000",additionalContainerStyles, overlay, imageStyles }) => {
    return (
      <div className={`bg-red_500 card-background w-full relative rounded-lg overflow-hidden shadow-lg group transition-transform duration-300 ease-in-out ${link === null && otherLinks === "javascript:void(0)" ? " cursor-default":""} ${additionalContainerStyles} md:min-h-105`}>
      <a href={otherLinks} onClick={link} >
       <img
        src={imageSrc}
        alt={title}
        className={`w-full h-full object-cover ${link === null && otherLinks === "javascript:void(0)" ? " cursor-default":"transform group-hover:scale-105 transition-transform duration-500 ease-in-out object-contain" } ${imageStyles}`}
      />
      <div className={`absolute bottom-0 left-0 right-0 p-5 bg-opacity-75 backdrop-blur-2xl text-white text-left ${overlay} `}>
        <div className="font-semibold text-body_lg md:text-body_lg text-negative mb-2">{title}</div>
        <p className=" text-subtitle md:text-body_base text-negative">{description}</p>
      </div>
      </a>
      </div>
    );
  };
  
  export default Card;
  
